import { daysBetween, fmtDate, todayIso } from '../../shared/data/common';

// Hotels, rooms and prices come live from /api/hotels. Popular destinations are searched by name;
// the results page looks each one up, so no supplier ids are kept here.
export const popularDestinations = [
  ['Goa', 'Beaches, shacks & heritage villas'],
  ['New Delhi', 'Business hotels near Connaught Place & Aerocity'],
  ['Mumbai', 'Sea-facing stays in Bandra, Juhu & South Mumbai'],
  ['Jaipur', 'Palaces, havelis & boutique stays'],
  ['Bengaluru', 'Business and boutique hotels'],
  ['Udaipur', 'Lake-view palaces'],
  ['Hyderabad', 'Hitech City & Banjara Hills'],
  ['Dubai', 'Downtown, Marina & Palm Jumeirah'],
];

// Penalty times are India time and arrive without a zone, e.g. "2026-11-17T17:58:00".
const day = (iso) => fmtDate(String(iso).slice(0, 10), { day: 'numeric', month: 'short', year: 'numeric' });
const clock = (iso) => {
  const [h, m] = String(iso).slice(11, 16).split(':').map(Number);
  return Number.isNaN(h) ? '' : `${((h + 11) % 12) + 1}:${String(m).padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}`;
};
const at = (iso) => `${day(iso)}${clock(iso) ? `, ${clock(iso)}` : ''}`;

/** "Free cancellation until 17 Nov 2026" from a rate's cancellation, or null. */
export const freeCancellationText = (cancellation) => (cancellation?.refundable && cancellation.freeCancellationUntil
  ? `Free cancellation until ${day(cancellation.freeCancellationUntil)}`
  : null);

/** One line per penalty window: "Until 17 Nov 2026, 5:58 PM: free cancellation", "From …: ₹5,657 charged". */
export const penaltyLines = (cancellation, formatAmount) => (cancellation?.penalties || []).map((p) => (
  p.penalty > 0 ? `From ${at(p.from)} (India time): ${formatAmount(p.penalty)} charged` : `Until ${at(p.to)} (India time): free cancellation`
));

/** Option type → how to label its rooms. */
export const optionTypeLabel = {
  SameRoomSameMeal: null,
  SameRoomMixedMeals: 'Meal plans differ by room',
  MixedRoomsSameMeal: 'Mixed rooms',
  MixedRoomsMixedMeals: 'Mixed rooms & meals',
};

/** Refund estimate for demo bookings saved before live hotels; live bookings are quoted by the API. */
export function hotelRefund(booking) {
  const days = daysBetween(todayIso(), booking.travelDate);
  if (days < 0) return { amount: 0, note: 'Check-in date has passed.' };
  if (booking.summary.freeCancel && days >= 1) return { amount: booking.fare.total, note: 'Free cancellation — full refund.' };
  const oneNight = (booking.summary.pricePerNight || 0) * (booking.summary.rooms || 1);
  return { amount: Math.max(0, booking.fare.total - oneNight), note: 'First night charged as cancellation fee.' };
}
